import React from "react";
// import PropTypes from "prop-types";
import { uniqueId } from "lodash";
import { Form } from "react-bootstrap";
import styles from "./styles/Question.module.css";
import clsx from "clsx";

const SingleChoiceQuestion = (props) => {
  const {
    options,
    userAnswer,
    onChange,
    // correctAnswer,
    // isCorrect,
    showAnswer,
  } = props;
  // state

  // variables

  // logics before hooks

  // hooks

  // logics

  // UI partials

  // effects

  // render
  const questionId = uniqueId();
  return (
    <Form>
      {options.map((opt) => {
        let className = "";
        if (showAnswer && userAnswer[0] === opt.id) {
          if (opt.isCorrectAnswer) {
            className = styles.correctAnswer;
          } else {
            className = styles.wrongAnswer;
          }
        }

        if (showAnswer && opt.isCorrectAnswer) {
          className = styles.correctAnswer;
        }

        return (
          <Form.Check
            key={opt.id}
            type="radio"
            label={opt.title}
            name={questionId}
            id={opt.id}
            checked={userAnswer[0] === opt.id}
            onChange={() => {
              !showAnswer && onChange([opt.id]);
            }}
            className={clsx(styles.option, className)}
          />
        );
      })}
    </Form>
  );
};

/* required: display name */
SingleChoiceQuestion.displayName = "SingleChoiceQuestion";

/* required: props types */
SingleChoiceQuestion.propTypes = {};

/* required: default props */
SingleChoiceQuestion.defaultProps = {};

export { SingleChoiceQuestion };
